// src/router/index.js

import { createRouter, createWebHistory } from 'vue-router'
import '../assets/vendor/@fortawesome/fontawesome-free/css/all.min.css'
import '../assets/vendor/remixicon/fonts/remixicon.css'
import '../assets/vendor/phosphor-icons/Fonts/regular/style.css'
import '../assets/vendor/phosphor-icons/Fonts/bold/style.css'
import '../assets/vendor/phosphor-icons/Fonts/fill/style.css'
import { getAccessTokenToCookies, getAccessToken, isAuthInProgress } from '@/shared/utils/tokenHelper'
import { isStoriesCreateEnabled } from '@/shared/config/stories.config'
import { isGuestModeEnabled, isGuestPostPath, guestDebug } from '@/shared/config/guest.config'
import {
  isGuestSession,
  shouldUseAuthenticatedPostDetail,
} from '@/shared/utils/authSession.util'

const childRoutes = (prop, mode) => [
  {
    path: '',
    name: prop + '.list',
    meta: { auth: true, name: 'Social App' },
    component: () => import('@/domains/social/views/SocialApp')
  },
  {
    path: 'accountsetting',
    name: prop + '.accountsetting',
    meta: { auth: true, name: 'Account Setting' },
    component: () => import('@/domains/profile/views/AccountSetting')
  },


  {
    path: 'profile/:storyId?',
    name: prop + '.profilemain',
    meta: { auth: true, name: 'Profile' },
    component: () => import('@/domains/profile/views/Profile')
  },
  // I added friend profile here not the other one
  {
    path: 'friendprofile/:id/:storyId?',
    name: prop + '.friendprofile',
    meta: { auth: true, name: 'Friend Profile' },
    component: () => import('@/domains/profile/views/FriendProfile')
  },

  {
    path: 'search',
    name: prop + '.search',
    meta: { auth: true, name: 'Search Results' },
    component: () => import('@/domains/search/views/SearchResults')
  },
  {
    path: 'events',
    name: prop + '.events-list',
    meta: { auth: true, name: 'Events' },
    component: () => import('@/domains/events/views/EventsListPage.vue')
  },
  {
    path: 'events/:id',
    name: prop + '.event-detail',
    meta: { auth: true, name: 'Event Detail' },
    component: () => import('@/domains/events/views/EventDetailPage.vue')
  },
  {
    path: 'profilebadges',
    name: prop + '.profilebadges',
    meta: { auth: true, name: 'Profile Badges' },
    component: () => import('@/domains/profile/components/features/ProfileBadges')
  },
  {
    path: 'group',
    name: prop + '.group',
    meta: { auth: true, name: 'Groups' },
    component: () => import('@/domains/groups/views/GroupsList')
  },
  {
    path: 'group-detail/:groupId?',
    name: prop + '.group-detail',
    meta: { auth: true, name: 'Groups' },
    component: () => import('@/domains/groups/views/GroupDetail')
  },
  {
    path: 'group-edit/:groupId?',
    name: prop + '.group-edit',
    meta: { auth: true, name: 'Edit group' },
    component: () => import('@/domains/groups/views/GroupEditPage')
  },
  {
    path: 'friendlist',
    name: prop + '.friendlist',
    meta: { auth: true, name: 'Friend Lists' },
    component: () => import('@/domains/friends/views/FriendList')
  },
  {
    path: 'collection',
    name: prop + '.collection',
    meta: { auth: true, name: 'Collection' },
    component: () => import('@/domains/profile/views/collection')
  },
  // {
  //   path: 'friendprofile',
  //   name: prop + '.friendprofile',
  //   meta: { auth: true, name: 'Friend profile' },
  //   component: () => import('../views/SocailMain/Friends/FriendProfile')
  // },

  {
    path: 'birthday',
    name: prop + '.birthday',
    meta: { auth: true, name: 'Birthday' },
    component: () => import('@/domains/birthdays/views/Birthday')
  },
  {
    path: 'notification',
    name: prop + '.notification',
    meta: { auth: true, name: 'Notification' },
    component: () => import('@/domains/notifications/views/Notification')
  },
  {
    path: 'post/:postId',
    name: prop + '.post-detail',
    meta: { auth: true, name: 'Post Detail' },
    component: () => import('@/domains/posts/views/PostDetail')
  },
  {
    path: 'posts/tags/:tagName',
    name: prop + '.hashtag-feed',
    meta: { auth: true, name: 'Hashtag Feed' },
    component: () => import('@/domains/posts/views/HashtagFeed.vue')
  },
  {
    path: 'rtik',
    name: prop + '.reels',
    meta: { auth: true, name: 'Rtik' },
    component: () => import('@/domains/posts/views/Reels.vue')
  },
  {
    path: 'friendrequest',
    name: prop + '.friendrequest',
    meta: { auth: true, name: 'Friend Request' },
    component: () => import('@/domains/friends/views/FriendRequest')
  },
  {
    path: 'weather',
    name: prop + '.weather',
    meta: { auth: true, name: 'Weather' },
    component: () => import('@/domains/social/views/OpenWeatherMap')
  },
  {
    path: 'prayer-times',
    name: prop + '.prayer-times',
    meta: { auth: true, name: 'Prayer Times' },
    component: () => import('@/domains/prayer-times/views/PrayerTimes.vue')
  },
  {
    path: 'page-view/:id?',
    name: prop + '.pageview',
    meta: { auth: true, name: 'Page View' },
    component: () => import('@/domains/pages/views/PageView.vue')
  },
  {
    path: 'page-create',
    name: prop + '.pagecreate',
    meta: { auth: true, name: 'Create Page' },
    component: () => import('@/domains/pages/views/CreatePage.vue')
  },
  {
    path: 'page-list',
    name: prop + '.pagelist',
    meta: { auth: true, name: 'Pages' },
    component: () => import('@/domains/pages/views/PageList.vue')
  },
  {
    path: 'story/create',
    name: prop + '.story-create',
    meta: { auth: true, name: 'Create Story' },
    component: () => import('@/domains/stories/views/StoryCreatePage.vue')
  },
  {
    path: 'story/:storyId',
    name: prop + '.story-detail',
    meta: { auth: true, name: 'Story Detail' },
    component: () => import('@/domains/stories/views/StoryPage.vue')
  },
  {
    path: '/birthdays',
    name: prop + '.birthdays',
    component: () => import('@/domains/birthdays/views/BirthdayList.vue')
  },
  {
    path: 'wallet',
    name: prop + '.wallet',
    meta: { auth: true, name: 'Wallet' },
    redirect: { name: 'gamification.portefeuille' }
  }
]
const blankchildRoutes = (prop, mode) => [
  {
    path: 'signin',
    name: prop + '.sign-in1',
    component: () => import('@/domains/auth/views/SignIn')
  },
  {
    path: 'signup',
    name: prop + '.sign-up1',
    component: () => import('@/domains/auth/views/SignUp')
  },
  {
    path: 'complete-registration',
    name: prop + '.complete-registration',
    component: () => import('@/domains/auth/views/CompleteRegistration')
  },
  {
    path: 'verify-account/:email',
    name: prop + '.verify-account',
    component: () => import('@/domains/auth/views/VerifyEmail')
  },
  {
    path: 'recoverpassword',
    name: prop + '.recoverpassword1',
    component: () => import('@/domains/auth/views/RecoverPassword')
  },
  {
    path: 'delete-user',
    name: prop + '.delete-user',
    component: () => import('@/domains/auth/views/DeleteUser')
  },
  {
    path: 'contact-us',
    name: prop + '.contact-us',
    component: () => import('@/domains/auth/views/ContactUs')
  }
]
const chatChildRoutes = (prop, mode) => [
  {
    path: 'chat/:conversationId?',
    name: prop + '.chat',
    component: () => import('@/domains/chat/views/ChatIndex')
  }
]
const pagesChildRoutes = (prop, mode = false) => [
  {
    path: 'error/:code',
    name: prop + '.error',
    component: () => import('@/shared/views/ErrorPage')
  },
  {
    path: 'error404',
    name: prop + '.error404',
    component: () => import('@/shared/views/Error404')
  },
  {
    path: 'error500',
    name: prop + '.error500',
    component: () => import('@/shared/views/Error500')
  },
  {
    path: 'maintenance',
    name: prop + '.maintenance',
    component: () => import('@/shared/views/Maintenance')
  },
  {
    path: 'maintenance-mode',
    name: prop + '.maintenance-mode',
    component: () => import('@/shared/views/MaintenanceMode')
  }
]
const appChildRoute = (prop, mode = false) => [
  {
    path: 'calendar',
    name: prop + '.calendar',
    meta: { auth: true, name: 'Calendar And Events', img: require('../assets/images/page-img/profile-bg6.jpg') },
    component: () => import('@/domains/calendar/components/features/CustomCalendar.vue')
  },
  {
    path: 'todo',
    name: prop + '.todo',
    meta: { auth: true, name: 'Todo' },
    component: () => import('@/domains/todos/views/TodoListing')
  },
  {
    path: 'students',
    meta: { auth: true, name: 'Students Inlab' },
    component: () => import('@/domains/students/views/StudentsShellView.vue'),
    children: [
      {
        path: '',
        name: prop + '.students',
        meta: { auth: true, name: 'Students Inlab' },
        component: () => import('@/domains/students/views/StudentsDiscoveryView.vue'),
      },
      {
        path: 'saved',
        name: prop + '.students.saved',
        meta: { auth: true, name: 'Students — Saved' },
        component: () => import('@/domains/students/views/StudentsSavedView.vue'),
      },
      {
        path: 'applied',
        name: prop + '.students.applied',
        meta: { auth: true, name: 'Students — Applied' },
        component: () => import('@/domains/students/views/StudentsAppliedView.vue'),
      },
    ],
  },
  {
    path: 'students/:projectId/apply',
    name: prop + '.students.apply',
    meta: { auth: true, name: 'Students — Apply' },
    component: () => import('@/domains/students/views/StudentApplicationView.vue')
  },
  {
    path: 'students/:projectId',
    name: prop + '.students.detail',
    meta: { auth: true, name: 'Students — Detail' },
    component: () => import('@/domains/students/views/StudentProjectDetailView.vue')
  },
  {
    path: 'soccer',
    name: prop + '.soccer',
    meta: { auth: true, name: 'Soccer' },
    component: () => import('@/domains/soccer/views/Soccer.vue')
  },
  {
    path: 'soccer/favorites',
    name: prop + '.soccer.favorites',
    meta: { auth: true, name: 'Favorites' },
    component: () => import('@/domains/soccer/views/Favorites.vue')
  },
  {
    path: 'soccer/league/:leagueId',
    name: prop + '.soccer.league',
    meta: { auth: true, name: 'League Detail' },
    component: () => import('@/domains/soccer/views/LeagueDetail.vue')
  },
  {
    path: 'soccer/match/:matchId',
    name: prop + '.soccer.match',
    meta: { auth: true, name: 'Match Detail' },
    component: () => import('@/domains/soccer/views/MatchDetail.vue')
  },
  {
    path: 'soccer/team/:teamId',
    name: prop + '.soccer.team',
    meta: { auth: true, name: 'Team Detail' },
    component: () => import('@/domains/soccer/views/TeamDetail.vue')
  }
]
const userChildRoute = (prop, mode = false) => [
  {
    path: 'profile-edit',
    name: prop + '.profile-edit',
    meta: { auth: true, name: 'Edit Profile' },
    component: () => import('@/domains/profile/views/ProfileEdit')
  },
  {
    path: 'accountsetting',
    name: prop + '.accountsetting',
    meta: { auth: true, name: 'Account Setting' },
    component: () => import('@/domains/profile/views/AccountSetting')
  },
  {
    path: 'privacysetting',
    name: prop + '.privacy-setting',
    meta: { auth: true, name: 'Privacy Setting' },
    component: () => import('@/domains/profile/views/PrivacySetting')
  }
]

const forumsChildRoutes = (prop, mode = false) => [
  {
    path: '',
    name: prop + '.all-forum',
    meta: { auth: true, name: 'All Forums' },
    component: () => import('@/domains/forums/components/features/ForumMain.vue')
  },
  {
    path: 'my-forum',
    name: prop + '.my-forum',
    meta: { auth: true, name: 'My Forums' },
    component: () => import('@/domains/forums/components/features/MyForum.vue')
  },
  {
    path: 'create',
    name: prop + '.create-forum',
    meta: { auth: true, name: 'Create Forum' },
    component: () => import('@/domains/forums/components/features/CreateForum.vue')
  },

  {
    path: 'invitation-forum',
    name: prop + '.invitation-forum',
    meta: { auth: true, name: 'Forum Invitations' },
    component: () => import('@/domains/forums/components/features/InvitationForum.vue')
  },
  {
    path: ':id/edit',
    name: prop + '.edit-forum',
    meta: { auth: true, name: 'Edit Forum' },
    component: () => import('@/domains/forums/components/features/EditForum.vue')
  },
  {
    path: ':id/add-topic',
    name: prop + '.add-topic',
    meta: { auth: true, name: 'Create Topic' },
    component: () => import('@/domains/forums/components/features/CreateTopic.vue')
  },
  {
    path: ':topicId/:answerId',
    name: prop + '.view-answer',
    meta: { auth: true, name: 'View Answer' },
    component: () => import('@/domains/forums/components/features/ViewAnswer.vue')
  },
  {
    path: ':forumId/topics/:topicId',
    name: prop + '.view-topic',
    meta: { auth: true, name: 'View Topic' },
    component: () => import('@/domains/forums/components/features/ViewTopic.vue')
  },
  {
    path: ':id',
    name: prop + '.view-forum',
    meta: { auth: true, name: 'View Forum' },
    component: () => import('@/domains/forums/components/features/ViewForum.vue')
  }
]

const marketChildRoutes = (prop, mode = false) => [
  {
    path: '',
    name: prop,
    redirect: { name: prop + '.for-you' },
  },
  {
    path: 'for-you',
    name: prop + '.for-you',
    meta: { guestMarket: true, auth: false, name: 'For You' },
    component: () => import('@/domains/market/views/Market')
  },
  {
    path: 'saved-articles',
    name: prop + '.saved-articles',
    meta: { auth: true, name: 'Saved Articles' },
    component: () => import('@/domains/market/views/SavedArticles')
  },
  {
    path: 'seller-detail/:sellerId',
    name: prop + '.seller-detail',
    meta: { auth: true, name: 'Seller Details' },
    component: () => import('@/domains/market/views/SellerDetail')
  },
  {
    path: 'article-create',
    name: prop + '.article-create',
    meta: { auth: true, name: 'Create Article' },
    component: () => import('@/domains/market/views/ArticleCreate')
  },
  {
    path: 'article-edit/:articleId',
    name: prop + '.article-edit',
    meta: { auth: true, name: 'Edit Article' },
    component: () => import('@/domains/market/views/ArticleEdit')
  },
  {
    path: 'article-detail/:articleId',
    name: prop + '.article-detail',
    meta: { guestMarket: true, auth: false, name: 'Article Detail' },
    component: () => import('@/domains/market/views/ArticleDetail')
  },
]

const gamificationChildRoutes = (prop, mode = false) => [
  {
    path: 'espace',
    name: prop + '.espace',
    meta: { auth: true, name: 'Espace Tik' },
    component: () => import('@/domains/gamification/views/EspaceTikView.vue')
  },
  {
    path: 'ligues',
    name: prop + '.ligues',
    meta: { auth: true, name: 'Ligues' },
    component: () => import('@/domains/leagues/views/LeaguesView.vue')
  },
  {
    path: 'classement',
    name: prop + '.classement',
    meta: { auth: true, name: 'Classement & Ligues 1Tik' },
    component: () => import('@/domains/leagues/views/ClassementLiguesView.vue')
  },
  {
    path: 'cadeaux',
    name: prop + '.cadeaux',
    meta: { auth: true, name: 'Cadeaux' },
    component: () => import('@/domains/leagues/views/CadeauxView.vue')
  },
  {
    path: 'historiques',
    name: prop + '.ligues-historiques',
    meta: { auth: true, name: 'Historiques' },
    component: () => import('@/domains/leagues/views/LeaguesHistoryView.vue')
  },
  {
    path: 'portefeuille',
    name: prop + '.portefeuille',
    meta: { auth: true, name: 'Portefeuille' },
    component: () => import('@/domains/wallet/views/WalletView.vue')
  },
  {
    path: 'store',
    name: prop + '.store',
    meta: { auth: true, name: '1Tik Store' },
    component: () => import('@/domains/store/views/StoreView.vue')
  },
  {
    path: 'store/brand/:brandId',
    name: prop + '.store-brand',
    meta: { auth: true, name: 'Store Brand' },
    component: () => import('@/domains/store/views/StoreBrandView.vue')
  },
  {
    path: 'store/brand/:brandId/article/:articleId',
    name: prop + '.store-article',
    meta: { auth: true, name: 'Store Article' },
    component: () => import('@/domains/store/views/StoreArticleView.vue')
  },
  {
    path: 'success',
    name: prop + '.success',
    meta: { auth: true, name: 'Success' },
    component: () => import('@/domains/gamification/views/GamificationSuccessView.vue')
  },
]

const routes = [
  {
    path: '/post/:postId',
    name: 'guest.post-detail',
    meta: { guestPost: true, auth: false, name: 'Post Preview' },
    component: () => import('@/domains/posts/views/GuestPostDetail.vue'),
  },
  {
    path: '/',
    name: 'social',
    component: () => import('../layouts/Default'),
    children: childRoutes('social')
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../layouts/Empty.vue'),
    children: blankchildRoutes('auth1')
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import('../layouts/Empty.vue'),
    children: chatChildRoutes('chat')
  },
  {
    path: '/pages',
    name: 'pages',
    component: () => import('../layouts/Empty.vue'),
    children: pagesChildRoutes('default')
  },
  {
    path: '/app',
    name: 'app',
    component: () => import('../layouts/Default'),
    meta: { auth: true },
    children: appChildRoute('app')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../layouts/Default'),
    meta: { auth: true },
    children: userChildRoute('user')
  },
  {
    path: '/termofservice',
    name: 'termofservice',
    meta: { name: 'Terms Of Use' },
    component: () => import('@/shared/views/TermsOfService.vue')
  },
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    meta: { name: 'Privacy Policy' },
    component: () => import('@/shared/views/PrivacyPolicy.vue')
  },
  {
    path: '/market',
    meta: { auth: false },
    children: marketChildRoutes('market'),
    component: () => import('../layouts/Default'),
  },
  {
    path: '/forums',
    name: 'forums',
    meta: { auth: true },
    component: () => import('../layouts/Default'),
    children: [
      {
        path: '',
        name: 'forums.wrapper',
        component: () => import('@/domains/forums/views/AllForums.vue'),
        children: forumsChildRoutes('forums')
      }
    ]
  },
  {
    path: '/gamification',
    meta: { auth: true },
    redirect: { name: 'gamification.espace' },
    component: () => import('../layouts/Default'),
    children: [
      {
        path: '',
        name: 'gamification',
        component: () => import('@/domains/gamification/components/shared/GamificationLayout.vue'),
        children: gamificationChildRoutes('gamification'),
      },
    ],
  },

  // ─── Live streams ───────────────────────────────────────────────────────
  // Feed page uses Default layout (sidebar + header)
  {
    path: '/live',
    name: 'live',
    meta: { auth: true },
    component: () => import('../layouts/Default'),
    children: [
      {
        path: '',
        name: 'live.feed',
        meta: { auth: true, name: 'Live Feed' },
        component: () => import('@/domains/live/views/LiveFeedPage'),
      },
    ],
  },
  // Full-screen live views — direct component (position:fixed overlays, no layout wrapper needed)
  {
    path: '/live/preview',
    name: 'live.preview',
    meta: { auth: true, name: 'Host Preview' },
    component: () => import('../layouts/Empty'),
    redirect: { name: 'live.preview.screen' },
    children: [
      {
        path: '',
        name: 'live.preview.screen',
        component: () => import('@/domains/live/views/HostPreviewScreen'),
      },
    ],
  },
  {
    path: '/live/host',
    name: 'live.host',
    meta: { auth: true, name: 'Host Live' },
    component: () => import('../layouts/Empty'),
    redirect: { name: 'live.host.screen' },
    children: [
      {
        path: '',
        name: 'live.host.screen',
        component: () => import('@/domains/live/views/HostLiveScreen'),
      },
    ],
  },
  {
    path: '/live/host/end',
    name: 'live.host.end',
    meta: { auth: true, name: 'Host End' },
    component: () => import('../layouts/Empty'),
    redirect: { name: 'live.host.end.screen' },
    children: [
      {
        path: '',
        name: 'live.host.end.screen',
        component: () => import('@/domains/live/views/HostEndScreen'),
      },
    ],
  },
  {
    // OBS / RTMP broadcast management page (creator gets RTMP url + stream key).
    // Static segment so it ranks above the `/live/:id` viewer route.
    path: '/live/obs',
    name: 'live.obs',
    meta: { auth: true, name: 'Broadcast with OBS' },
    component: () => import('../layouts/Default'),
    children: [
      {
        path: '',
        name: 'live.obs.screen',
        component: () => import('@/domains/live/views/ObsBroadcastPage.vue'),
      },
    ],
  },
  {
    path: '/live/:id',
    name: 'live.viewer',
    meta: { auth: true, name: 'Viewer Live' },
    component: () => import('../layouts/Empty'),
    redirect: (to) => ({ name: 'live.viewer.screen', params: to.params }),
    children: [
      {
        path: '',
        name: 'live.viewer.screen',
        component: () => import('@/domains/live/views/ViewerLiveScreen'),
      },
    ],
  },
  {
    path: '/live/:id/ended',
    name: 'live.viewer.end',
    meta: { auth: true, name: 'Viewer End' },
    component: () => import('../layouts/Empty'),
    redirect: (to) => ({ name: 'live.viewer.end.screen', params: to.params }),
    children: [
      {
        path: '',
        name: 'live.viewer.end.screen',
        component: () => import('@/domains/live/views/ViewerEndScreen'),
      },
    ],
  },

  // ─── Soccer V2 ───────────────────────────────────────────────────────
  {
    path: '/soccer-v2',
    name: 'soccer-v2',
    meta: { auth: true },
    component: () => import('../layouts/Default'),
    children: [
      {
        path: '',
        name: 'soccer-v2.shell',
        component: () => import('@/domains/soccer-v2/views/SoccerV2.vue'),
        children: [
          {
            path: '',
            name: 'soccer-v2.home',
            meta: { auth: true, name: 'Live Football' },
            component: () => import('@/domains/soccer-v2/views/SoccerV2Home.vue'),
          },
          {
            path: 'world-cup',
            name: 'soccer-v2.world-cup',
            meta: { auth: true, name: 'World Cup 2026' },
            component: () => import('@/domains/soccer-v2/views/SoccerV2WorldCup.vue'),
          },
          {
            path: 'live',
            name: 'soccer-v2.live',
            meta: { auth: true, name: 'Live Matches' },
            component: () => import('@/domains/soccer-v2/views/SoccerV2Live.vue'),
          },
          {
            path: 'leagues',
            name: 'soccer-v2.leagues',
            meta: { auth: true, name: 'Leagues' },
            component: () => import('@/domains/soccer-v2/views/SoccerV2Leagues.vue'),
          },
          {
            path: 'standings',
            name: 'soccer-v2.standings',
            meta: { auth: true, name: 'Standings' },
            component: () => import('@/domains/soccer-v2/views/SoccerV2Standings.vue'),
          },
          {
            path: 'favorites',
            name: 'soccer-v2.favorites',
            meta: { auth: true, name: 'Favorites' },
            component: () => import('@/domains/soccer-v2/views/SoccerV2Favorites.vue'),
          },
          {
            path: 'search',
            name: 'soccer-v2.search',
            meta: { auth: true, name: 'Search' },
            component: () => import('@/domains/soccer-v2/views/SoccerV2SearchPage.vue'),
          },
        ],
      },
      {
        path: 'league/:leagueId',
        name: 'soccer-v2.league',
        meta: { auth: true, name: 'League Detail' },
        component: () => import('@/domains/soccer-v2/views/LeagueDetail.vue'),
      },
      {
        path: 'match/:matchId',
        name: 'soccer-v2.match',
        meta: { auth: true, name: 'Match Detail' },
        component: () => import('@/domains/soccer-v2/views/MatchDetail.vue'),
      },
      {
        path: 'team/:teamId',
        name: 'soccer-v2.team',
        meta: { auth: true, name: 'Team Detail' },
        component: () => import('@/domains/soccer-v2/views/TeamDetail.vue'),
      },
      {
        path: 'player/:playerId',
        name: 'soccer-v2.player',
        meta: { auth: true, name: 'Player Detail' },
        component: () => import('@/domains/soccer-v2/views/PlayerDetail.vue'),
      },
    ],
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top
    return { top: 0 };
  },
})

const isUseCookies = process.env.VUE_APP_USE_COOKIES === 'true';

// Handle chunk loading errors - reload page if chunk fails to load
router.onError((error) => {
  const pattern = /Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module/i;
  const isChunkLoadError = error.message && error.message.match(pattern);
  const isChunkLoadErrorType = error.name === 'ChunkLoadError';

  if (isChunkLoadError || isChunkLoadErrorType) {
    // Chunk failed to load, likely due to new deployment
    // Clear cache and reload
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    // Reload the page to get fresh chunks
    window.location.reload();
  }
});

router.beforeEach(async (to, from) => {
  if (!isStoriesCreateEnabled() && to.meta?.name === 'Create Story') {
    return { name: 'social.list' };
  }

  // Skip router guard for API paths - these should be handled by backend/nginx
  // If someone accidentally navigates to /auth/google (without /api/), redirect to backend API
  if (to.path === '/auth/google' || to.path === '/auth/apple') {
    // Redirect to backend API OAuth endpoint
    const apiPath = to.path === '/auth/google' ? '/apimain/auth/google' : '/apimain/auth/apple';
    window.location.href = `${window.location.origin}${apiPath}`;
    return false; // Prevent navigation
  }

  // ✅ BETTER APPROACH: Reset auth state when navigating to auth pages
  // This allows users to log in again after logout without needing special endpoint checks
  const isAuthPage = to.name === 'auth1.sign-in1' ||
    to.name === 'auth1.sign-up1' ||
    to.name === 'auth1.recoverpassword1' ||
    to.name === 'auth1.verify-account' ||
    to.name === 'auth1.delete-user' ||
    to.name === 'auth1.complete-registration';

  if (isAuthPage) {
    const { useAuthStore } = await import('@/domains/auth/store/authStore');
    const authStore = useAuthStore();
    // Reset logged out state to allow login attempts
    if (authStore.isLoggedOut) {
      authStore.markAsLoggedIn(); // Reset to allow API calls for login
    }
  }

  // Check if auth is in progress (Safari fix for storage timing)
  const authInProgress = isAuthInProgress();

  // Cache token check to avoid repeated storage access
  let token;
  let hasUserData = false;

  try {
    if (isUseCookies) {
      // For cookie-based auth, httpOnly cookies cannot be read by JavaScript
      // Check if we have user data instead (which indicates valid session)
      const { userStore } = await import('@/shared/store/userStore');
      const store = userStore();
      hasUserData = store.isUserFetched && store.getUser().id;
      // For cookie auth, we can't read the token, so check user data or auth in progress
      token = hasUserData || authInProgress ? 'cookie-auth' : null;
    } else {
      // ✅ FIX: For JWT auth, get token and validate it's not empty/null/undefined
      token = getAccessToken(); // Checks both localStorage and sessionStorage
      // Additional validation: ensure token is a valid string
      if (token && (token === 'null' || token === 'undefined' || token.trim() === '')) {
        token = null;
      }
    }
  } catch (error) {
    // If token access fails, treat as no token
    console.debug('[Router] Token check error:', error);
    token = null;
  }

  // Safari fix: If auth is in progress and we're navigating to home, allow it
  // even if token isn't immediately readable (storage timing issue)
  // This prevents redirect loops in Safari where storage writes are delayed
  if (authInProgress && to.path === '/' && !token) {
    // Allow navigation - token will be available soon (auth flag is set)
    return true;
  }

  /*
   If there is a token then redirect the user to home page and don't
   let the user view the login or signup page
   */
  if ((
    to.name === 'auth1.sign-in1'
    || to.name === 'auth1.sign-up1'
  ) && token) {
    try {
      const { getOAuthOnboardingStatus } = await import('@/domains/auth/services/auth.service');
      const status = await getOAuthOnboardingStatus();
      if (status.success && status.requiresOnboarding) {
        const redirect = typeof to.query.redirect === 'string' ? to.query.redirect : undefined;
        return {
          name: 'auth1.complete-registration',
          ...(redirect ? { query: { redirect } } : {}),
        };
      }
    } catch (error) {
      console.debug('[Router] OAuth onboarding check on auth page skipped:', error);
    }
    return { name: 'social.list' }
  }

  // /post/:id — authenticated users → full post detail; anonymous → guest preview
  if (isGuestModeEnabled() && isGuestPostPath(to.path)) {
    const postId = to.params?.postId;
    guestDebug('router:post-path', {
      to: to.fullPath,
      toName: to.name,
      postId,
      hasToken: !!token,
      isGuestSession: isGuestSession(),
      shouldAuthPost: shouldUseAuthenticatedPostDetail(),
    });
    if (postId) {
      if (shouldUseAuthenticatedPostDetail()) {
        if (to.name !== 'social.post-detail') {
          guestDebug('router:redirect → social.post-detail (authenticated)');
          return {
            name: 'social.post-detail',
            params: { postId },
            query: to.query,
          };
        }
      } else if (isGuestSession() && to.name !== 'guest.post-detail') {
        guestDebug('router:redirect → guest.post-detail (anonymous)');
        return {
          name: 'guest.post-detail',
          params: { postId },
          query: to.query,
        };
      }
    }
  }

  const isGuestPublicRoute =
    to.name === 'guest.post-detail'
    || to.meta?.guestPost === true
    || to.meta?.guestMarket === true;

  if (isGuestPublicRoute) {
    guestDebug('router:guest-public-route', {
      to: to.fullPath,
      toName: to.name,
      guestModeEnabled: isGuestModeEnabled(),
      isGuestSession: isGuestSession(),
      hasToken: !!token,
      whitelisted: isGuestModeEnabled() && isGuestPublicRoute,
    });
  }

  /*
  If the user is trying to view any page and there is not a token then
  redirect him to the login page
  BUT: Allow navigation if auth is in progress (prevents redirect loop in Safari)
  For cookie-based auth, also check if we have user data (indicates valid session)
  */
  if (!(
    to.name === 'auth1.sign-in1'
    || to.name === 'auth1.sign-up1'
    || to.name === 'auth1.recoverpassword1'
    || to.name === 'auth1.complete-registration'
    || to.name === 'termofservice'
    || to.name === 'privacypolicy'
    || to.name === 'auth1.verify-account'
    || to.name === 'auth1.delete-user'
    || to.name === 'auth1.contact-us'
    || (isGuestModeEnabled() && isGuestPublicRoute)
  ) && isGuestSession()) {
    // For cookie-based auth, if we have user data, allow navigation (cookies are valid)
    if (isUseCookies && hasUserData) {
      guestDebug('router:allow (cookie session has user data)', { to: to.fullPath });
    } else {
      guestDebug('router:redirect → auth1.sign-in1 (not whitelisted, guest session)', {
        to: to.fullPath,
        toName: to.name,
        isGuestPublicRoute,
        guestModeEnabled: isGuestModeEnabled(),
        guestWhitelistActive: isGuestModeEnabled() && isGuestPublicRoute,
      });
      return { name: 'auth1.sign-in1', query: { redirect: to.fullPath } }
    }
  }

  // ✅ SIMPLIFIED: Router guard only checks user data availability
  // With hydration pattern, user data should be available immediately from cache
  // main.js handles fetching - router just verifies data exists
  // Note: isAuthPage already defined above, reuse it
  const skipUserHydration =
    isGuestPublicRoute
    || to.name === 'termofservice'
    || to.name === 'privacypolicy'
    || to.name === 'auth1.complete-registration';

  if (token && !isAuthPage && !skipUserHydration) {
    const { userStore } = await import('@/shared/store/userStore');
    const store = userStore();

    // With hydration, user data should already be available from cache
    // If not available (edge case), wait briefly for main.js fetch to complete
    // For cookie-based auth, if no user data, try fetching (cookies might be valid but not checked yet)
    if (!store.isUserFetched || !store.getUser().id) {
      // For cookie-based auth, try fetching user data if we don't have it
      // This handles the case where cookies exist but user data wasn't fetched yet
      if (isUseCookies && !store.isLoading) {
        // Don't await - let it fetch in background, router will wait for it below
        store.fetchCurrentUser().catch(() => {
          // If fetch fails, cookies are likely invalid - will be handled by API interceptor
        });
      }

      const maxWait = 500; // Reduced from 2000ms to 500ms
      const checkInterval = 50; // Reduced from 100ms to 50ms for faster checks
      const startTime = Date.now();

      // Create a non-blocking wait function with optimized polling
      const waitForUserData = () => new Promise((resolve) => {
        const checkData = () => {
          if (store.isUserFetched && store.getUser().id) {
            // User data is now available
            resolve(true);
          } else if (Date.now() - startTime >= maxWait) {
            // Timeout reached, proceed anyway
            // For cookie-based auth, cookies might be valid but API call failed
            // Allow navigation and let API interceptor handle auth errors
            resolve(false);
          } else {
            // Check again after interval (non-blocking)
            setTimeout(checkData, checkInterval);
          }
        };
        checkData();
      });

      // Wait for user data without blocking the main thread
      await waitForUserData();
    }
  }

  if (token && !isAuthPage) {
    try {
      const { useLiveStore } = await import('@/domains/live/store/liveStore')
      const { LIVE_PHASES } = await import('@/domains/live/constants/liveConfig')
      const liveStore = useLiveStore()
      const hostAllowed = new Set([
        'live.host', 'live.host.screen', 'live.host.end', 'live.host.end.screen',
        'live.preview', 'live.preview.screen',
      ])
      if (
        (to.name === 'live.host.screen' || to.name === 'live.host') &&
        !liveStore.isHostingSession &&
        liveStore.phase !== LIVE_PHASES.CONNECTED_HOST
      ) {
        if (!liveStore.hasServerActiveLive) {
          await liveStore.checkForActiveLive()
        }
        if (liveStore.canResumeHostLive || liveStore.hasServerActiveLive) {
          // HostLiveScreen shows resume gate when session exists on server
        } else {
          return { name: 'live.preview.screen' }
        }
      }
      if (
        liveStore.isHostingSession &&
        (liveStore.phase === LIVE_PHASES.CONNECTED_HOST ||
          liveStore.phase === LIVE_PHASES.RECONNECTING) &&
        !hostAllowed.has(to.name)
      ) {
        const { default: i18n } = await import('@/i18n')
        const { confirmHostLeaveAndEnd, getRouteAfterHostEnd } = await import(
          '@/domains/live/utils/liveHostExitGuard'
        )
        const t = i18n.global.t.bind(i18n.global)
        const ok = await confirmHostLeaveAndEnd(liveStore, t)
        if (!ok) return false
        const afterEnd = getRouteAfterHostEnd(liveStore)
        if (afterEnd && to.name !== afterEnd.name) return afterEnd
      }
    } catch { /* live module optional */ }
  }

  return true
})

// Plausible Analytics - Automatic page view tracking
router.afterEach((to, from) => {
  // Track page views automatically on route changes
  if (typeof window !== 'undefined' && window.plausible) {
    try {
      // Use Plausible's built-in pageview tracking
      // This will automatically track the new route
      window.plausible('pageview', {
        u: to.fullPath
      });
    } catch (error) {
      console.debug('[Plausible] Error tracking pageview:', error);
    }
  }
});

// Fennec mode: auto-activate on feed page, deactivate when leaving
router.afterEach(async (to) => {
  try {
    const { useFennecStore } = await import('@/domains/mode-fennec/store/fennecStore');
    const fennecStore = useFennecStore();
    fennecStore.handleRouteChange(to.name);
  } catch (e) {
    // store not ready yet
  }
});

export default router
